import React from 'react';
import {
  Alert,
  Box,
  Button,
  CircularProgress,
  Paper,
  Tab,
  Tabs,
  Typography
} from '@mui/material';
import AddIcon from '@mui/icons-material/Add';
import SemanticDatabaseCard from './SemanticDatabaseCard';

const SemanticDatabaseSection = ({
  activeRecords,
  deletedRecords,
  filter,
  onFilterChange,
  onCreate,
  onView,
  onEdit,
  onDelete,
  isLoading,
  error,
  connectionsIndex,
  tableCountByDatabase = {},
  onOpenTables
}) => {
  const recordsToRender = filter === 'deleted' ? deletedRecords : activeRecords;

  return (
    <Paper
      elevation={0}
      sx={{
        bgcolor: 'var(--wb-bg-elevated)',
        p: 3,
        borderRadius: 2,
        mb: 4
      }}
    >
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          mb: 3,
          flexWrap: 'wrap',
          gap: 2
        }}
      >
        <Box>
          <Typography variant="h6" color="var(--wb-text-strong)">
            Bases de datos semánticas
          </Typography>
          <Tabs
            value={filter}
            onChange={(_, value) => onFilterChange(value)}
            textColor="secondary"
            indicatorColor="secondary"
            sx={{ mt: 1 }}
          >
            <Tab
              label={`Activas (${activeRecords.length})`}
              value="active"
              sx={{ color: 'var(--wb-text)' }}
            />
            <Tab
              label={`Eliminadas (${deletedRecords.length})`}
              value="deleted"
              sx={{ color: 'var(--wb-text)' }}
            />
          </Tabs>
        </Box>

        <Button
          variant="contained"
          startIcon={<AddIcon />}
          onClick={onCreate}
          sx={{
            bgcolor: 'var(--wb-primary)',
            '&:hover': { bgcolor: 'var(--wb-primary-hover)' }
          }}
        >
          Nueva base semántica
        </Button>
      </Box>

      {error && (
        <Alert severity="error" sx={{ mb: 2 }}>
          {error}
        </Alert>
      )}

      {isLoading ? (
        <Box sx={{ display: 'flex', justifyContent: 'center', py: 6 }}>
          <CircularProgress sx={{ color: 'var(--wb-accent)' }} />
        </Box>
      ) : recordsToRender.length === 0 ? (
        <Box sx={{ textAlign: 'center', py: 6 }}>
          <Typography variant="body1" color="var(--wb-text-strong)">
            {filter === 'deleted'
              ? 'No hay bases de datos semánticas eliminadas.'
              : 'A?n no se han registrado bases de datos semánticas.'}
          </Typography>
        </Box>
      ) : (
        recordsToRender.map((item) => (
          <SemanticDatabaseCard
            key={item.semantic_database_id}
            record={item}
            connectionName={connectionsIndex[item.connection_id]?.connection_name}
            connectionType={connectionsIndex[item.connection_id]?.connection_type}
            tableCount={tableCountByDatabase[item.semantic_database_id] || 0}
            onOpenTables={onOpenTables}
            onView={onView}
            onEdit={onEdit}
            onDelete={onDelete}
            isDeleted={filter === 'deleted' || item?.soft_delete?.deleted}
          />
        ))
      )}
    </Paper>
  );
};

export default SemanticDatabaseSection;